import styled from "styled-components";

// Page header
export const PageHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 24px;

  @media (min-width: 768px) {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
`;

export const PageHeaderDiscount = styled.div`
  display: flex;
  justify-content: flex-end;
  width:100%;
`;

export const PageTitle = styled.h1`
  font-size: 24px;
  font-weight: 600;
  color: #1e293b;
  margin: 0;

  @media (min-width: 768px) {
    font-size: 28px;
  }
`;

export const AddVoucherButton = styled.button`
  background-color: #76B041;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 12px 24px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s;
  width: 100%;

  &:hover {
    background-color: #65a30d;
  }

  @media (min-width: 768px) {
    width: auto;
    min-width: 140px;
  }
`;



export const SectionTitle = styled.h2`
  font-size: 20px;
  font-weight: 600;
  color: #1e293b;
  margin: 0 0 20px 0;

  @media (min-width: 768px) {
    font-size: 22px;
  }
`;

// Voucher sections
export const VoucherSection = styled.div`
  margin-bottom: 32px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const SectionHeader = styled.h3`
  font-size: 16px;
  font-weight: 500;
  color: #5A5A5A;
  margin: 0 0 16px 0;

  @media (min-width: 768px) {
    font-size: 14px;
  }
`;

export const EmptyState = styled.div`
  text-align: center;
  padding: 40px 20px;
  color: #64748b;
  font-size: 16px;

  @media (min-width: 768px) {
    padding: 60px 20px;
  }
`;

// Voucher cards
export const VoucherGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
gap:8px;
  @media (min-width: 768px) {
    grid-template-columns: 1fr 1fr;
  }

  @media (min-width: 1024px) {
    grid-template-columns: 1fr 1fr;
  }

  @media (min-width: 1280px) {
    grid-template-columns: 1fr 1fr 1fr 1fr;
  }
`;

export const VoucherCard = styled.div`
  background: white;
  border-radius: 12px;
  padding: 0px;
  position: relative;
`;

export const VoucherName = styled.h4`
  font-size: 16px;
  font-weight: 600;
  color: #e39435;
  margin: 0 0 8px 0;
`;

export const VoucherValue = styled.div`
  font-size: 14px;
  color: #1e293b;
  margin-bottom: 8px;

  @media (min-width: 768px) {
    font-size: 18px;
  }
`;

export const VoucherPeriod = styled.div`
  font-size: 12px;
  color: #64748b;
  margin-bottom: 12px;

  @media (min-width: 768px) {
    font-size: 14px;
  }
`;

export const VoucherActions = styled.div`
  display: flex;
  gap: 8px;
  margin-top: 12px;
`;

export const ActionButton = styled.button<{ $variant?: 'primary' | 'secondary' | 'danger' }>`
  padding: 8px 16px;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  flex: 1;

  ${props => {
    switch (props.$variant) {
      case 'primary':
        return `
          background-color: #e39435;
          color: white;
          &:hover { background-color: #d97706; }
        `;
      case 'danger':
        return `
          background-color: #ef4444;
          color: white;
          &:hover { background-color: #dc2626; }
        `;
      default:
        return `
          background-color: #f1f5f9;
          color: #64748b;
          &:hover { background-color: #e2e8f0; }
        `;
    }
  }}
`;

// Create Voucher Form Styles
export const CreateVoucherContainer = styled.div`
  width: 100%;
  min-height: 100vh;
  padding: 16px;
`;

export const CreateVoucherHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 24px;

  @media (min-width: 1024px) {
    margin-bottom: 32px;
  }
`;

export const BackButton = styled.button`
  background: none;
  border: none;
  color: white;
  font-size: 20px;
  cursor: pointer;
  padding: 8px;
  border-radius: 4px;
  transition: background-color 0.2s;

  &:hover {
    background-color: rgba(255, 255, 255, 0.1);
  }

  @media (min-width: 1024px) {
    font-size: 24px;
    padding: 12px;
  }
`;

export const CreateVoucherTitle = styled.h1`
  font-size: 20px;
  font-weight: 600;
  color: white;
  margin: 0;

  @media (min-width: 768px) {
    font-size: 24px;
  }

  @media (min-width: 1024px) {
    font-size: 28px;
  }
`;

export const FormContainer = styled.div`
  background: white;
  border-radius: 12px;
`;

export const FormField = styled.div`
  margin-bottom: 16px;
  width:100%;

  @media (min-width: 1024px) {
    margin-bottom: 24px;
  }
`;

export const FormLabel = styled.label`
  display: block;
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 8px;

  @media (min-width: 1024px) {
    font-size: 16px;
    margin-bottom: 10px;
  }

  &::after {
    content: ${props => props.children?.toString().includes('*') ? '' : ''};
  }
`;

export const FormInput = styled.input<{ $hasError?: boolean }>`
  width: 100%;
  padding: 12px 16px;
  border: 1px solid ${props => props.$hasError ? '#ef4444' : '#e2e8f0'};
  border-radius: 6px;
  font-size: 16px;
  transition: all 0.2s ease;
  box-sizing: border-box;
  background-color: #fafafa;
height:56px;
  @media (min-width: 1024px) {
    padding: 14px 18px;
    font-size: 16px;
    background-color: #fbfbfb;
  }

  &:focus {
    outline: none;
    border-color: ${props => props.$hasError ? '#ef4444' : '#76B041'};
    background-color: white;
    box-shadow: 0 0 0 3px ${props => props.$hasError ? 'rgba(239, 68, 68, 0.1)' : 'rgba(118, 176, 65, 0.1)'};
  }

  &:hover:not(:focus) {
    border-color: ${props => props.$hasError ? '#ef4444' : '#c1c1c1'};
  }

  &::placeholder {
    color: #94a3b8;
  }
`;

export const ErrorMessage = styled.div`
  color: #ef4444;
  font-size: 12px;
  margin-top: 4px;

  @media (min-width: 1024px) {
    font-size: 13px;
    margin-top: 6px;
  }
`;

export const DiscountTypeSection = styled.div`
  margin-bottom: 20px;
width : 100%;

  @media (min-width: 768px) {
    margin-bottom: 24px;
    max-width: 75%;
  }

  @media (min-width: 1280px) {
    margin-bottom: 24px;
    max-width: 50%;
  }
`;

export const DiscountTypeLabel = styled.div`
  font-size: 16px;
  font-weight: 500;
  color: #1e293b;
  margin-bottom: 12px;

  @media (min-width: 1024px) {
    font-size: 18px;
    margin-bottom: 16px;
  }
`;

export const DiscountTypeButtons = styled.div`
  display: flex;
  gap: 12px;

  @media (min-width: 1024px) {
    gap: 16px;
  }
`;

export const DiscountTypeButton = styled.button<{ $active: boolean }>`
  flex: 1;
  padding: 12px 16px;
  border: 1px solid ${props => props.$active ? '#76B041' : '#e2e8f0'};
  border-radius: 24px;
  background-color: ${props => props.$active ? '#76B041' : 'white'};
  color: ${props => props.$active ? 'white' : '#64748b'};
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;

  @media (max-width: 767px) {
    padding: 8px 12px;
    font-size: 13px;
  }

  @media (min-width: 1024px) {
    padding: 14px 20px;
    font-size: 15px;
  }

  &:hover {
    border-color: #76B041;
    background-color: ${props => props.$active ? '#65a30d' : '#f0fdf4'};
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }

  &:active {
    transform: translateY(0);
  }
`;

export const DateTimeField = styled.div`
  position: relative;
`;

export const DateTimeInput = styled.input`
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  font-size: 14px;
  background-color: white;
  min-height: 50px;

  &:focus {
    outline: none;
    border-color: #76B041;
    box-shadow: 0 0 0 2px rgba(118, 176, 65, 0.1);
  }

  /* Style built-in calendar icon */
  &::-webkit-calendar-picker-indicator {
    width: 18px;
    height: 18px;
    cursor: pointer;
    filter: invert(0.6);
    transform: scale(1.2);
  }

  /* Hide Firefox datetime picker button */
  &::-moz-datetime-picker-button {
    display: none;
  }

  /* Force dd/MM/yy format display */
  &[type="datetime-local"] {
    /* Override browser default formatting */
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: textfield;
    
    /* Custom styling for better dd/MM/yy display */
    letter-spacing: 0.5px;
    
    /* Ensure consistent formatting across browsers */
    &::-webkit-inner-spin-button,
    &::-webkit-outer-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
    
    /* Firefox specific styling */
    &::-moz-focus-inner {
      border: 0;
      padding: 0;
    }
  }

  /* Placeholder styling for better UX */
  &::placeholder {
    color: #94a3b8;
    letter-spacing: normal;
  }

  /* Focus state enhancements */
  &:focus {
    &::placeholder {
      opacity: 0.7;
    }
  }
`;

export const CalendarIcon = styled.div`
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 20px;
  pointer-events: auto;
  cursor: pointer;
  padding: 4px;
  border-radius: 6px;
  transition: all 0.2s ease;
  color: #E39435;
  @media (min-width: 1024px) {
    right: 8px;
    font-size: 22px;
  }
`;

export const CalendarPopup = styled.div<{ $isOpen: boolean }>`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  padding: 16px;
  margin-top: 4px;
  display: ${props => props.$isOpen ? 'block' : 'none'};

  @media (min-width: 1024px) {
    padding: 20px;
  }
`;

export const CalendarInput = styled.input`
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  font-size: 14px;
  background-color: white;
  
  &:focus {
    outline: none;
    border-color: #76B041;
    box-shadow: 0 0 0 2px rgba(118, 176, 65, 0.1);
  }
`;

export const WarningMessage = styled.div`
  color: #dc2626;
  font-size: 12px;
  margin-top: 4px;
  display: flex;
  align-items: center;
  gap: 4px;
  
  @media (min-width: 1024px) {
    font-size: 13px;
  }
`;

export const WarningIcon = styled.span`
  font-size: 14px;
  
  @media (min-width: 1024px) {
    font-size: 15px;
  }
`;

export const ReviewButton = styled.button`
  width: 100%;
  background-color: #76B041;
  color: white;
  border: none;
  border-radius: 6px;
  padding: 16px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;

  @media (min-width: 768px) {
    max-width: 200px;
  }
    
  @media (min-width: 1024px) {
    padding: 18px 24px;
    font-size: 17px;
    border-radius: 10px;
    width: 200px;
  }

  &:disabled {
    background-color: #94a3b8;
    cursor: not-allowed;
    transform: none;
    box-shadow: none;
  }
`;

// Review Modal Components
export const ReviewModalOverlay = styled.div<{ $isOpen: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: ${props => props.$isOpen ? 'flex' : 'none'};
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 16px;
`;

export const ReviewModalContent = styled.div`
  background: white;
  border-radius: 12px;
  padding: 24px;
  width: 100%;
  max-width: 600px;
  max-height: 90vh;
  overflow-y: auto;
  position: relative;
`;

export const ReviewModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 1px solid #e2e8f0;
`;

export const ReviewModalTitle = styled.h2`
  font-size: 20px;
  font-weight: 600;
  color: #111827;
  margin: 0;
`;

export const ReviewModalCloseButton = styled.button`
  background: none;
  border: none;
  font-size: 24px;
  color: #6b7280;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  
  &:hover {
    background-color: #f3f4f6;
    color: #374151;
  }
`;

export const ReviewSection = styled.div`
  margin-bottom: 20px;
`;

export const ReviewSectionTitle = styled.h3`
  font-size: 16px;
  font-weight: 600;
  color: #374151;
  margin: 0 0 12px 0;
`;

export const ReviewDetailRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid #f3f4f6;
  
  &:last-child {
    border-bottom: none;
  }
`;

export const ReviewDetailLabel = styled.span`
  font-size: 14px;
  color: #6b7280;
  font-weight: 500;
`;

export const ReviewDetailValue = styled.span`
  font-size: 14px;
  color: #111827;
  font-weight: 600;
  text-align: right;
`;

export const ReviewModalActions = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 24px;
  padding-top: 16px;
  border-top: 1px solid #e2e8f0;
  
  @media (max-width: 767px) {
    flex-direction: column;
  }
`;

export const ReviewBackButton = styled.button`
  flex: 1;
  background-color: #f3f4f6;
  color: #374151;
  border: none;
  border-radius: 6px;
  padding: 12px 16px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    background-color: #e5e7eb;
  }
`;

export const ReviewConfirmButton = styled.button`
  flex: 1;
  background-color: #76B041;
  color: white;
  border: none;
  border-radius: 6px;
  padding: 12px 16px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    background-color: #65a30d;
  }
  
  &:disabled {
    background-color: #94a3b8;
    cursor: not-allowed;
  }
`;

// Modal styles
export const ModalOverlay = styled.div<{ $visible: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  opacity: ${props => props.$visible ? 1 : 0};
  visibility: ${props => props.$visible ? 'visible' : 'hidden'};
  transition: opacity 0.2s, visibility 0.2s;
  padding: 16px;
`;

export const ModalContent = styled.div`
  background: white;
  border-radius: 12px;
  padding: 24px;
  max-width: 400px;
  width: 100%;
  text-align: center;
`;

export const ModalTitle = styled.h3`
  font-size: 18px;
  font-weight: 600;
  color: #1e293b;
  margin: 0 0 12px 0;
`;

export const ModalMessage = styled.p`
  font-size: 14px;
  color: #64748b;
  margin: 0 0 24px 0;
  line-height: 1.5;
`;

export const ModalActions = styled.div`
  display: flex;
  gap: 12px;
`;

export const ModalButton = styled.button<{ $variant?: 'primary' | 'secondary' }>`
  flex: 1;
  padding: 12px 16px;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s;

  ${props => props.$variant === 'primary' ? `
    background-color: #76B041;
    color: white;
    &:hover { background-color: #65a30d; }
  ` : `
    background-color: #f1f5f9;
    color: #64748b;
    border: 1px solid #e2e8f0;
    &:hover { background-color: #e2e8f0; }
  `}
`;

// Carousel Components
export const CarouselContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
`;

export const CarouselButton = styled.button<{ $disabled?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border: 2px solid ${({ $disabled }) => $disabled ? '#e0e0e0' : '#e39435'};
  background-color: ${({ $disabled }) => $disabled ? '#f5f5f5' : 'white'};
  border-radius: 8px;
  cursor: ${({ $disabled }) => $disabled ? 'not-allowed' : 'pointer'};
  transition: all 0.2s ease;
  color: ${({ $disabled }) => $disabled ? '#bdbdbd' : '#e39435'};
  font-size: 18px;
  font-weight: bold;

  &:hover {
    background-color: ${({ $disabled }) => $disabled ? '#f5f5f5' : '#e39435'};
    color: ${({ $disabled }) => $disabled ? '#bdbdbd' : 'white'};
  }

  &:active {
    transform: ${({ $disabled }) => $disabled ? 'none' : 'scale(0.95)'};
  }

  @media (max-width: 767px) {
    width: 36px;
    height: 36px;
    font-size: 16px;
  }
`;

export const CarouselInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #666;
  min-width: 120px;
  justify-content: center;

  @media (max-width: 767px) {
    font-size: 12px;
    min-width: 100px;
  }
`;

export const CarouselDots = styled.div`
  display: flex;
  gap: 6px;
  align-items: center;
`;

export const CarouselDot = styled.button<{ $active?: boolean }>`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  border: none;
  background-color: ${({ $active }) => $active ? '#e39435' : '#e0e0e0'};
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background-color: ${({ $active }) => $active ? '#d18429' : '#bdbdbd'};
  }
`;

export const VoucherPill = styled.div<{ $expired?: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  isolation: isolate;
  padding: 12px 16px 12px 16px;
  gap: 8px;
  border-radius: 15px;
  background: ${(p) => (p.$expired ? "#E2DED9" : "#FCEFD9")};
`;

export const DiscountBlock = styled.div<{ $expired?: boolean }>`
  /* PriceHighL */
  width: 120px;
  border-radius: 30px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 2px;
  color: ${(p) => (p.$expired ? "#A5A5A5" : "#E39435")};
`;

export const DiscountValue = styled.div<{ $expired?: boolean }>`
  /* 10% */
  font-weight: 700;
  font-size: 32px;
  line-height: 38px; /* identical to box height */
  color: ${(p) => (p.$expired ? "#A5A5A5" : "#E39435")};
`;

export const DiscountMeta = styled.div<{ $expired?: boolean }>`
  /* Cap / Min. Spend */
  font-weight: 500;
  font-size: 12px;
  line-height: 14px;
  text-align: center;
  color: #A5A5A5;
`;

export const VoucherDivider = styled.div<{ $expired?: boolean }>`
  /* Line 14 - vertical divider */
  width: 2px;
  height: 60px;
  background: ${(p) => (p.$expired ? "#A5A5A5" : "#E5DED4")};
`;

export const VoucherInfo = styled.div<{ $expired?: boolean }>`
  /* Frame 8138 */
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  gap: 0;
  padding: 0;
  min-height: 57px;
  margin-left: 25px; /* gap between blocks */
`;

export const VoucherInfoName = styled.div<{ $expired?: boolean }>`
  /* Title */
  font-size: 16px;
  font-weight: 700;
  line-height: 19px;
  color: ${(p) => (p.$expired ? "#A5A5A5" : "#E39435")};
`;

export const VoucherInfoPeriod = styled.div<{ $expired?: boolean }>`
  /* Date range */
  font-weight: 500;
  font-size: 10px;
  line-height: 12px;
  color: #A5A5A5;
`;
